import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { up } from "@/lib/text";

const F = ({ label, children, className = "" }) => (
  <div className={`space-y-1 ${className}`}><Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>{children}</div>
);

// Comma-separated list <-> array helper for contacts / phones / emails
const listStr = (arr) => (Array.isArray(arr) ? arr.join(", ") : arr || "");
const toList = (s) => s.split(",").map((x) => x.trim()).filter(Boolean);

export const blankMaster = () => ({ legal_name: "", brand_name: "", contact_persons: "", phones: "", emails: "", country: "", addresses: [""], gstin: "", pan: "", iec: "", other_ids: "", notes: "" });

export const masterPayload = (f) => ({
  legal_name: up(f.legal_name), brand_name: up(f.brand_name), country: up(f.country),
  contact_persons: toList(up(listStr(f.contact_persons))), phones: toList(listStr(f.phones)), emails: toList(listStr(f.emails).toLowerCase()),
  gstin: up(f.gstin), pan: up(f.pan), iec: up(f.iec), other_ids: up(f.other_ids), notes: f.notes || "",
  ...(f.addresses ? { addresses: f.addresses.map(up).filter(Boolean) } : {}),
});

export const CustomerMasterFields = ({ form, setForm, showAddresses = true, prefix = "cm" }) => {
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const setAddr = (i, v) => setForm((f) => ({ ...f, addresses: f.addresses.map((a, idx) => (idx === i ? v : a)) }));
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <F label="Legal Company Name *"><Input data-testid={`${prefix}-legal-name`} value={form.legal_name} onChange={(e) => set("legal_name", up(e.target.value))} placeholder="ACME TEXTILES PVT LTD" /></F>
        <F label="Brand / Trading Name"><Input data-testid={`${prefix}-brand-name`} value={form.brand_name} onChange={(e) => set("brand_name", up(e.target.value))} placeholder="ACME" /></F>
        <F label="Contact Person(s)"><Input data-testid={`${prefix}-contacts`} value={listStr(form.contact_persons)} onChange={(e) => set("contact_persons", up(e.target.value))} placeholder="Comma separated" /></F>
        <F label="Mobile / WhatsApp(s)"><Input data-testid={`${prefix}-phones`} value={listStr(form.phones)} onChange={(e) => set("phones", e.target.value)} placeholder="+91 98765 43210, …" /></F>
        <F label="Email(s)"><Input data-testid={`${prefix}-emails`} value={listStr(form.emails)} onChange={(e) => set("emails", e.target.value)} placeholder="a@b.com, …" /></F>
        <F label="Country"><Input data-testid={`${prefix}-country`} value={form.country} onChange={(e) => set("country", up(e.target.value))} placeholder="INDIA" /></F>
      </div>
      {showAddresses && (
        <div className="space-y-2">
          <Label className="text-xs uppercase tracking-wider text-muted-foreground">Address(es) · first = default</Label>
          {form.addresses.map((a, i) => (
            <Textarea key={i} data-testid={`${prefix}-address-${i}`} rows={2} value={a} onChange={(e) => setAddr(i, up(e.target.value))} className="resize-none" placeholder={i === 0 ? "DEFAULT ADDRESS" : "ADDITIONAL ADDRESS"} />
          ))}
          <button type="button" data-testid={`${prefix}-add-address`} onClick={() => set("addresses", [...form.addresses, ""])} className="text-xs text-primary hover:underline">+ Add another address</button>
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <F label="GSTIN"><Input data-testid={`${prefix}-gstin`} value={form.gstin} onChange={(e) => set("gstin", up(e.target.value))} /></F>
        <F label="PAN"><Input data-testid={`${prefix}-pan`} value={form.pan} onChange={(e) => set("pan", up(e.target.value))} /></F>
        <F label="IEC"><Input data-testid={`${prefix}-iec`} value={form.iec} onChange={(e) => set("iec", up(e.target.value))} /></F>
        <F label="Other IDs"><Input data-testid={`${prefix}-other-ids`} value={form.other_ids} onChange={(e) => set("other_ids", up(e.target.value))} placeholder="VAT / TIN…" /></F>
      </div>
      <F label="Notes"><Textarea data-testid={`${prefix}-notes`} rows={2} value={form.notes} onChange={(e) => set("notes", e.target.value)} className="resize-none" placeholder="Free-form notes (normal case)" /></F>
    </div>
  );
};
